import { useGetAllTimeGreatsLeadersQuery } from "../store/api/mlbApi";

export const useAllTimeGreatsLeaderboard = ({
  stat,
  page = 0,
  pageSize = 25,
} = {}) => {
  const { data, isLoading, isFetching, error } = useGetAllTimeGreatsLeadersQuery({
    stat,
    page: page + 1,
    pageSize,
  });

  return {
    data,
    results: data?.results || [],
    totalResults: data?.totalResults || 0,
    isLoading: isLoading || isFetching,
    error,
  };
};
